import { TechniciansQueryResult } from '@/graphql/generated/hooks'
import { DeviceType } from '@/graphql/generated/schemas'
import { Role } from '@/types/roles'

export { Role } from '@/types/roles'

// ExtendedRole provide useful extension of standard role system to support
// users outside of the organization and users without specific role within
// organization. Technicians don't have HiveWatch accounts and exist outside
// of the organization, whereas employees are organization members which are
// NOT program managers, operators or guards.
export enum RoleExtended {
  PROGRAM_MANAGER = 'PROGRAM_MANAGER',
  OPERATOR = 'OPERATOR',
  GUARD = 'GUARD',
  EMPLOYEE = 'EMPLOYEE',
  TECHNICIAN = 'TECHNICIAN',
  IMPLEMENTER = 'IMPLEMENTER',
}

export const DEFAULT_ROLE = 'default-roles-hivewatch-dev.com'

export const PERMITTED_USER_ROLES = [
  Role.OPERATOR,
  Role.PROGRAM_MANAGER,
  Role.READ_ONLY_USER,
  Role.IMPLEMENTER,
  DEFAULT_ROLE,
]

export const ROLE_OPTIONS = [
  { value: Role.OPERATOR, label: 'Operator' },
  { value: Role.PROGRAM_MANAGER, label: 'Program Manager' },
  { value: Role.GUARD, label: 'Guard' },
  { value: Role.READ_ONLY_USER, label: 'Read Only User' },
  { value: Role.IMPLEMENTER, label: 'Implementer' },
]

export type TechnicianFacilities =
  TechniciansQueryResult['data']['technicians']['edges']['0']['node']['facilities']

export interface AccountIProps {
  id: string
  email: string
  firstName: string
  lastName: string
  roles?: string[]
  roleName: RoleExtended | '' | 'default-roles-hivewatch-dev.com'
  facilities?: TechnicianFacilities
  deviceTypes?: DeviceType[]
}

export interface AccountGroupIProps {
  role: RoleExtended
  accounts: AccountIProps[]
}

export interface AccountGroupsIProps extends Array<AccountGroupIProps> {}

// Pending Invitee types for users who have been invited but haven't accepted yet
export interface PendingInviteeIProps {
  id: string
  email: string
  firstName: string
  lastName: string
  roles: string[]
  invitedAt: string
  lastInviteSentAt: string | null
  isExpired: boolean
}
